module.exports = __webpack_public_path__ + "static/media/TaskForwarding.22ef490.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/TaskForwarding.mp4
// module id = bJP3
// module chunks = 1